module.exports = __webpack_public_path__ + "b1d2fb4d0c9e0c83ae6c7bdf99e34c94.svg";